// @ts-nocheck

export const transformStringToBoolean = (obj) => {
  for (const key in obj) {
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      // If the property is an object or array, recursively call the function
      transformStringToBoolean(obj[key]);
    } else if (obj[key] === 'false') {
      // If the property is the string "false", convert it to boolean false
      obj[key] = false;
    } else if (obj[key] === 'true') {
      // If the property is the string "true", convert it to boolean true
      obj[key] = true;
    }
  }
  return obj;
};
